import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=261438d6&scoped=true&lang=pug"
import script from "./FaqList.vue?vue&type=script&lang=ts"
export * from "./FaqList.vue?vue&type=script&lang=ts"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=261438d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261438d6",
  null
  
)

export default component.exports